import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';

interface Payload {
  layoutType: LayoutType;
  tabId: string;
}

export const removeTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tabId } = payload;
  const sections = state[layoutType].sections;

  for (const section of sections) {
    if (section.tabId === tabId) {
      section.tabId = null;
    }
  }

  state[layoutType].tabs = state[layoutType].tabs.filter((tab) => tab.id !== tabId);
};
